const PARTNERS = [
  "Fußball",
  "Handball",
  "Basketball",
  "Volleyball",
  "Leichtathletik",
  "Turnen",
  "Schwimmen",
  "Rudern",
  "Tennis",
  "Hockey",
  "Tischtennis",
  "Judo",
];

export const Marquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="relative py-16 border-y border-white/[0.06] overflow-hidden"
      aria-label="Sportarten"
    >
      <div className="px-6 md:px-10 lg:px-16 mb-8">
        <p className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-white/35">
          Für jede Sportart, jede Liga, jede Vereinsgröße
        </p>
      </div>

      <div className="relative">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 md:w-40 z-10 bg-gradient-to-r from-navy-950 to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 md:w-40 z-10 bg-gradient-to-l from-navy-950 to-transparent" />

        <div className="flex w-max animate-marquee">
          {[...PARTNERS, ...PARTNERS].map((name, i) => (
            <div
              key={i}
              className="group flex items-center gap-4 px-10 shrink-0"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-brand-orange to-brand-blue" />
              <span className="font-display font-bold text-2xl md:text-3xl text-white/25 group-hover:text-white transition-colors duration-300 whitespace-nowrap">
                {name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
